/**
 * Form-fill line, like the labelled rows on a cassette insert:
 *
 *   NAME: ___________________
 *   REC DATE: ________________
 *
 * The label is rendered in mono caps (Space Mono) and the value can be a
 * script flourish or a plain serif/mono string, matching the references.
 */
type Props = {
  label: string;
  value: React.ReactNode;
  /** Font for the value. */
  valueFont?: 'script' | 'serif' | 'mono' | 'display';
  /** Tailwind text color class for the value. */
  valueColor?: string;
  className?: string;
};

const fontClass: Record<NonNullable<Props['valueFont']>, string> = {
  script: 'font-script text-3xl',
  serif: 'font-serif italic text-xl',
  mono: 'font-mono text-base',
  display: 'font-display uppercase text-2xl tracking-wider',
};

const LabelField = ({
  label,
  value,
  valueFont = 'script',
  valueColor = 'text-ink',
  className = '',
}: Props) => (
  <div className={`label-line flex items-end gap-3 pb-1 ${className}`}>
    <span className="font-mono text-xs font-bold uppercase tracking-retro text-ink-muted shrink-0">
      {label}:
    </span>
    <span className={`${fontClass[valueFont]} ${valueColor} leading-tight`}>{value}</span>
  </div>
);

export default LabelField;
